import { useMemo } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearActiveRating,
  clearRatingPayload,
  closeRatingModal,
  updateRatings,
} from '../../RatingSlice';
import { setMessage } from '../../../toasts/toastSlice';
import patchRating from './patchRating';
import { handleAxiosErrorMessage } from '../../../../utils';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPES } from '../../../../config/consts/commons';

function useConfirmRating() {
  const { t } = useTranslation(['system']);
  const dispatch = useDispatch();
  const { activeRating } = useSelector((store) => store.rating);

  const resetRating = () => {
    dispatch(updateRatings(activeRating.id));
    dispatch(clearActiveRating());
    dispatch(clearRatingPayload());
    dispatch(closeRatingModal());
  };

  const receiverName = useMemo(
    () =>
      `${activeRating?.user?.first_name} ${activeRating?.user?.last_name}` ??
      '',
    [activeRating]
  );

  return useMutation({
    mutationKey: ['confirmRating'],
    mutationFn: (data) => {
      return patchRating(data);
    },
    onMutate: ({ skipped }) => {
      if (skipped) clearRatingPayload();
    },
    onSuccess: (_, ratingData) => {
      const { skipped } = ratingData;

      if (!skipped)
        dispatch(
          setMessage({
            body: t('SAVE_RATING_SUCCESS', {
              ns: 'system',
              name: receiverName,
            }),
            type: NOTIFICATION_TYPES.SUCCESS,
          })
        );
      resetRating();
    },
    onError: (error) => {
      const errorMessage = handleAxiosErrorMessage(error);
      resetRating();
      dispatch(
        setMessage({
          body: t(errorMessage, { ns: 'system' }),
          type: NOTIFICATION_TYPES.ERROR,
        })
      );
    },
  });
}

export default useConfirmRating;
